import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/utils/config/config.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class EnlacesService {
  controller: string = "enlaces/";
  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService,
  ) { }

  createEnlace(data: any) {
    return this.http.post(this.config.apiUrl + this.controller + 'create', data, this.sesion.headers);
  }

  viewEnlace(id: string) {
    return this.http.get(this.config.apiUrl + this.controller + 'view/' + id, this.sesion.headers);
  }
}
